<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item> {{$t('entities.fieldManager.plural')}}</el-breadcrumb-item>
    </el-breadcrumb>

    <h2 class="page-title"> {{$t('entities.fieldManager.plural')}} </h2>


    <el-row :gutter="20">
      <el-col :xs="24" :md="8">
        <el-form @submit.native.prevent class="search" :inline="true">
          <el-form-item>
            <el-input v-model="pager.search" :placeholder="$t('table.search')">
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col class="button-group" :xs="24" :md="16">
        <el-button
          v-if="hasRoleToCreate"
          icon="el-icon-fa-file-o"
          @click="create()"
          type="primary"
        > {{$t('table.add')}}
        </el-button>
        <el-button
          v-if="hasRoleToReadLogs"
          icon="el-icon-fa-history"
          @click="history()"
          type="infor"
        >
            {{$t('table.history')}}
        </el-button>
        <el-button
          v-if="pager.hasDataToExport(list)"
          @click="pager.exportToCsv(list)"
          :plain="true"
          type="success"
          icon="el-icon-fa-table"
        >
           {{$t('table.export')}}
        </el-button>
      </el-col>
    </el-row>

    <el-table
       @row-click="rowClick"
      :data="pager.paginate(list)"
      :default-sort="{
        prop: 'name',
        order: 'ascending'
      }"
      empty-text="There are no managers yet"
      @sort-change="(args) => pager.sortChange(args)"
      style="width: 100%"
      v-loading="loading"
      border
    >
      <el-table-column
        prop="name"
        label="Name"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="lastName"
        label="LastName"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="email"
        label="Email"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="phone"
        label="Phone"
        sortable="custom"
      ></el-table-column>

      <!-- Actions -->
      <el-table-column
        :fixed="isMobile? undefined : 'right'"
        align="center"
        :label="$t('table.actions')"
        width="120"
      >
      <template slot-scope="scope">
        <el-dropdown trigger="click">
            <el-button class="el-dropdown-link" size="small" round>
                        <i class="el-icon-more"></i>
            </el-button>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  v-if="hasRoleToRead">
              <el-button
              icon="el-icon-fa-search"
              size="small"
              type="text"
              @click="show(scope.row.id)"
              >{{$t('table.details')}}
              </el-button>
            </el-dropdown-item>
            <el-dropdown-item  v-if="hasRoleToUpdate">
              <el-button
                icon="el-icon-fa-pencil-square-o"
                size="small"
                type="text"
                @click="edit(scope.row.id)"
              >
              {{$t('table.edit')}}
              </el-button>
            </el-dropdown-item>
            <el-dropdown-item  v-if="hasRoleToDelete">
               <el-button
              icon="el-icon-fa-trash"
              size="small"
              type="text"
              @click="destroy(scope.row.id)"
            >
              {{$t('table.delete')}}
              </el-button>

            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
        <!-- <template slot-scope="scope">
          <el-tooltip
            v-if="hasRoleToRead"
           :content="$t('table.details')"
            placement="top"
          >
            <el-button
              icon="el-icon-fa-search"
              size="small"
              type="text"
              @click="show(scope.row.id)"
            />
          </el-tooltip>

          <el-tooltip
            v-if="hasRoleToUpdate"
           :content="$t('table.edit')"
            placement="top"
          >
            <el-button
              icon="el-icon-fa-pencil-square-o"
              size="small"
              type="text"
              @click="edit(scope.row.id)"
            />
          </el-tooltip>

          <el-tooltip
            v-if="hasRoleToDelete"
           :content="$t('table.delete')"
            placement="top"
          >
            <el-button
              icon="el-icon-fa-trash"
              size="small"
              type="text"
              @click="destroy(scope.row.id)"
            />
          </el-tooltip>
        </template> -->
      </el-table-column>
    </el-table>

    <div class="mt-3">
      <el-pagination
        style="float: right"
        @size-change="(args) => pager.pageSizeChange(args)"
        :current-page.sync="pager.currentPage"
        :layout="paginationLayout"
        :total="pager.filteredAndSortedList(list).length"
        background
      ></el-pagination>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable */

export default {
  name: 'app-fieldManager-list',

  computed: {
    ...mapGetters({
      loading: 'entities/fieldManager/loading',
      list: 'entities/fieldManager/list',
      pager: 'entities/fieldManager/pager',
      hasRoleToDelete: "entities/fieldManager/hasRoleToDelete",
      hasRoleToUpdate: "entities/fieldManager/hasRoleToUpdate",
      hasRoleToRead: "entities/fieldManager/hasRoleToRead",
      hasRoleToReadLogs: "entities/fieldManager/hasRoleToReadLogs",
      hasRoleToCreate: "entities/fieldManager/hasRoleToCreate",
      isMobile: "shared/isMobile",
      paginationLayout: "shared/paginationLayout"
    }),
  },

  created() {
    this.$store.dispatch('entities/fieldManager/list');
  },


  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/fieldManager/clear');
    next();
  },

  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("entities/fieldManager/list");
    next();
  },

  methods: {
    create() {
      this.$router.push({
        name: 'fieldManagerNew',
      });
    },

    rowClick(row, column, cell, event) {
          if (cell.label !== this.$t("table.actions")) {
              this.$router.push({
                  name: "fieldManagerShow",
                  params: { id: row.id }
              });
          }
      },

    show(id) {
      this.$router.push({
        name: 'fieldManagerShow',
        params: { id },
      });
    },

    edit(id) {
      this.$router.push({
        name: 'fieldManagerEdit',
        params: { id },
      });
    },

    destroy(id) {
      this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
        confirmButtonText: this.$t("table.yes"),
        cancelButtonText: this.$t("table.no"),
        type: 'warning',
      })
        .then(() =>
          this.$store.dispatch(
            'entities/fieldManager/destroy',
            id,
          ),
        )
        .catch(() => {});
    },

    history() {
      this.$router.push({ name: 'fieldManagerHistoryFull' });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/field-manager/field-manager-list.vue?0fd76101